import React from "react";
import HOC from "../../components/HOC";
import ReturDetailProduct from "../../components/screen/Retur/ReturDetailProduct";
import PageTemplate from "../../components/common/particles.jsx/PageTemplate";
import { ThemeProvider } from "@mui/material";
import { theme } from "../../components/constants/muiTheme";
import BreadcrumbRetur from "../../components/screen/Retur/BreadcrumbRetur";

const ReturDetailProductPage = () => {
  return (
    <div className="">
      <PageTemplate
        header="Detail Retur Pembelian"
        mainComponent={
          <ThemeProvider theme={theme}>
            <ReturDetailProduct />
          </ThemeProvider>
        }
        breadcrumb={<BreadcrumbRetur />}
        pageRole={46}
      />
    </div>
  );
};

export default HOC(ReturDetailProductPage);
